import React, { useState, useEffect } from "react";
import "./style.css";
import API from "../../utils/API";
import Table from "react-bootstrap/Table";
import Moment from "react-moment";
import { storage } from "../../config/Fire";
import cogoToast from "@successtar/cogo-toast";

function PropertyPolicySummary({ propertyData, colSize, admin }) {
  const [formData, setFormData] = useState({
    editActivated: false,
    showProperty: false,
    uploaded: undefined,
    carrier: "",
    policyNumber: "",
    effectiveDate: "",
    dwelling: "",
    structures: "",
    persprop: "",
    lossofuse: "",
    liability: "",
    medical: "",
    deductible: "",
    premium: "",
    url: "",
    declaration: ""
  });

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      carrier: propertyData.carrier,
      policyNumber: propertyData.policyNumber,
      effectiveDate: propertyData.effectiveDate,
      dwelling: propertyData.dwelling,
      structures: propertyData.structures,
      persprop: propertyData.persprop,
      lossofuse: propertyData.lossofuse,
      liability: propertyData.liability,
      medical: propertyData.medical,
      deductible: propertyData.deductible,
      premium: propertyData.premium,
      url: propertyData.declaration
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const copyText = (event, data) => {
    event.preventDefault();
    if (data !== undefined) {
      navigator.clipboard.writeText(data);
      cogoToast.success("Copied: " + data);
    } else {
      cogoToast.error("Couldn't copy data");
    }
  };

  const fileSelectedHandler = (event) => {
    event.preventDefault();
    if (event.target.files[0]) {
      setFormData((prev) => ({
        ...prev,
        declaration: event.target.files[0]
      }));
    }
  };

  const fileUploadHandlerB = (event) => {
    setFormData((prev) => ({
      ...prev,
      uploaded: false
    }));
    event.preventDefault();
    const uploadTask = storage.ref(`*/${formData.declaration.name}`).put(formData.declaration);
    uploadTask.on(
      "state_changed",
      (_snapshot) => {},
      (error) => {
        console.log(error);
      },
      () => {
        storage
          .ref("*")
          .child(formData.declaration.name)
          .getDownloadURL()
          .then((urlB) => {
            setFormData((prev) => ({
              ...prev,
              declaration: urlB,
              uploaded: true
            }));
          });
      }
    );
  };

  const activateEdit = (e) => {
    e.preventDefault();
    setFormData((prev) => ({
      ...prev,
      editActivated: !prev.editActivated
    }));
  };

  const saveEdits = (e) => {
    e.preventDefault();
    API.updatePropertyPolicy(propertyData._id, {
      carrier: formData.carrier,
      policyNumber: formData.policyNumber,
      dwelling: formData.dwelling,
      structures: formData.structures,
      persprop: formData.persprop,
      lossofuse: formData.lossofuse,
      liability: formData.liability,
      medical: formData.medical,
      deductible: formData.deductible,
      premium: parseInt(formData.premium),
      declaration: formData.url
    })
      .then((_res) => {
        alert("You've updated this policy!");
      })
      .catch((_err) => alert("The edit did not go through!"));
  };

  const softDeleteProperty = (id) => {
    API.softDeleteProperty(id)
      .then((_res) => {
        alert("You've deleted this property policy");
      })
      .catch((_err) => alert("The deletion did not go through"));
  };

  const showProperty = () => {
    setFormData((prev) => ({
      ...prev,
      showProperty: !prev.showProperty
    }));
  };

  return (
    <div className="row">
      <div className={colSize}>
        {propertyData.policyActive ? (
          <div className="card" style={{ overflow: "auto" }}>
            <div className="card-header" style={{ color: "black" }}>
              <h5>
                <strong>{propertyData.carrier} Property</strong>
              </h5>
              <h6>
                <strong>Policy #: {propertyData.policyNumber}</strong>
              </h6>
              <button className="btn btn-success" onClick={showProperty}>
                Show / Hide
              </button>
              {admin ? (
                <button className="btn btn-warning" onClick={activateEdit}>
                  Edit
                </button>
              ) : null}
              {admin ? (
                <button
                  className="btn-danger btn"
                  onClick={() => softDeleteProperty(propertyData._id)}
                >
                  Delete
                </button>
              ) : null}
            </div>

            {formData.editActivated ? (
              <div className="card-body" style={{ backgroundColor: "white" }}>
                <Table responsive striped bordered hover>
                  <tbody>
                    <tr>
                      <th>
                        <strong></strong>
                      </th>
                      <th>
                        <strong></strong>
                      </th>
                    </tr>
                    <tr>
                      <td>
                        <strong>Carrier</strong>
                      </td>
                      <td>
                        <input
                          type="text"
                          onChange={handleInputChange}
                          value={formData.carrier}
                          name="carrier"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Policy Number</strong>
                      </td>
                      <td>
                        <input
                          type="text"
                          onChange={handleInputChange}
                          value={formData.policyNumber}
                          name="policyNumber"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Premium</strong>
                      </td>
                      <td>
                        <input
                          type="number"
                          onChange={handleInputChange}
                          value={formData.premium}
                          name="premium"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Effective Date</strong>
                      </td>
                      <td>
                        <Moment format="MM/DD/YYYY" add={{ hours: 8 }}>
                          {propertyData.effectiveDate}
                        </Moment>
                      </td>
                    </tr>
                  </tbody>
                </Table>

                <Table responsive striped bordered hover>
                  <tbody>
                    <tr>
                      <th>
                        <strong>Coverage</strong>
                      </th>
                      <th>
                        <strong>Amount</strong>
                      </th>
                    </tr>
                    <tr>
                      <td>
                        <strong>Dwelling Coverage</strong>
                      </td>
                      <td>
                        <input
                          type="text"
                          onChange={handleInputChange}
                          value={formData.dwelling}
                          name="dwelling"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Private Structures</strong>
                      </td>
                      <td>
                        <input
                          type="text"
                          onChange={handleInputChange}
                          value={formData.structures}
                          name="structures"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Personal Property</strong>
                      </td>
                      <td>
                        <input
                          type="text"
                          onChange={handleInputChange}
                          value={formData.persprop}
                          name="persprop"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Loss of Use</strong>
                      </td>
                      <td>
                        <input
                          type="text"
                          onChange={handleInputChange}
                          value={formData.lossofuse}
                          name="lossofuse"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Liability</strong>
                      </td>
                      <td>
                        <input
                          type="text"
                          onChange={handleInputChange}
                          value={formData.liability}
                          name="liability"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Medical Payments</strong>.
                      </td>
                      <td>
                        <input
                          type="text"
                          onChange={handleInputChange}
                          value={formData.medical}
                          name="medical"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Deductible</strong>
                      </td>
                      <td>
                        <input
                          type="text"
                          onChange={handleInputChange}
                          value={formData.deductible}
                          name="deductible"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Declarations</strong>
                      </td>
                      <td>
                        <input
                          style={{ width: "80%" }}
                          type="file"
                          onChange={fileSelectedHandler}
                        />
                        <button onClick={fileUploadHandlerB}>
                          Upload
                          <span>
                            {formData.uploaded === false ? (
                              <img alt="loading" src="/loading.gif" />
                            ) : null}
                            {formData.uploaded === true ? (
                              <img
                                alt="checkmark"
                                src="/checkmark.png"
                                style={{ height: "20px", width: "20px" }}
                              />
                            ) : null}
                          </span>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </Table>
                <button
                  style={{ textAlign: "center" }}
                  className="btn btn-success"
                  onClick={saveEdits}
                >
                  Save Edits
                </button>
              </div>
            ) : (
              <div className="card-body" style={{ backgroundColor: "white" }}>
                {formData.showProperty ? (
                  <>
                    <Table striped bordered hover responsive>
                      <tbody>
                        <tr>
                          <th>
                            <strong>Category</strong>
                          </th>
                          <th>
                            <strong></strong>
                          </th>
                        </tr>
                        <tr>
                          <td>
                            <strong>Carrier</strong>
                          </td>
                          <td>{propertyData.carrier}</td>
                        </tr>
                        <tr>
                          <td>
                            <strong>Policy Number</strong>
                          </td>
                          <td>
                            {propertyData.policyNumber}{" "}
                            <i
                              className="fa-solid fa-copy"
                              onClick={(e) => {
                                copyText(e, propertyData.policyNumber);
                              }}
                            ></i>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <strong>Premium</strong>
                          </td>
                          <td>${propertyData.premium}</td>
                        </tr>
                        <tr>
                          <td>
                            <strong>Effective Date</strong>
                          </td>
                          <td>
                            <Moment format="MM/DD/YYYY" add={{ hours: 8 }}>
                              {propertyData.effectiveDate}
                            </Moment>
                          </td>
                        </tr>
                      </tbody>
                    </Table>

                    <Table striped bordered hover responsive>
                      <tbody>
                        <tr>
                          <th>
                            <strong>Coverage</strong>
                          </th>
                          <th>
                            <strong>Amount</strong>
                          </th>
                        </tr>
                        <tr>
                          <td>
                            <strong>Dwelling</strong>
                          </td>
                          <td>
                            ${propertyData.dwelling}{" "}
                            <i
                              className="fa-solid fa-copy"
                              onClick={(e) => {
                                copyText(e, propertyData.dwelling);
                              }}
                            ></i>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <strong>Private Structures</strong>
                          </td>
                          <td>${propertyData.structures}</td>
                        </tr>
                        <tr>
                          <td>
                            <strong>Personal Property</strong>
                          </td>
                          <td>${propertyData.persprop}</td>
                        </tr>
                        <tr>
                          <td>
                            <strong>Personal Liability</strong>
                          </td>
                          <td>${propertyData.liability}</td>
                        </tr>
                        <tr>
                          <td>
                            <strong>Deductible</strong>
                          </td>
                          <td>${propertyData.deductible}</td>
                        </tr>
                        <tr>
                          <td>
                            <strong>Declarations Page</strong>
                          </td>
                          <td>
                            <a href={propertyData.declaration}>Download</a>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </>
                ) : null}
              </div>
            )}
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default PropertyPolicySummary;
